import React from 'react';

const LoadingState = () => {
  return (
    <div className="text-center my-5 py-5">
      <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <h5 className="text-muted">Đang tải dữ liệu...</h5>
    </div>
  );
};

export default LoadingState;

